module.exports = __webpack_public_path__ + "static/scale-model-of-masterson-station-park-in-lexington-kentucky-54aa219c8370282bdf7d1c4643f4e66f.png";